import React from 'react';
import { translate } from "sulu-admin-bundle/utils/Translator";
import style from '../scss/style.scss';

export default class TranslatableStringTransformer {
    transform(value, options) {
        if (!value) {
            return null;
        }

        return <span className={style.textBox} title={translate(`${options.baseKey}.${value}`)}>{translate(`${options.baseKey}.${value}`)}</span>;
    }
}
